module.exports = __webpack_public_path__ + "static/media/winSmall90_1.d736e65d.png";